import { DealType, IConfiguration, Maybe } from 'src/types/graphql'
import { getEffectiveDealType } from 'src/utils/pricing'

/**
 * Whether `availability` is a claim we can print as scarcity.
 *
 * - SpotMe Now (Monthly): yes — checkout approval decrements it and ending a
 *   rent restores it, so the platform itself keeps the count.
 * - Everything else (Traditional, Pro): only when the server says the host's
 *   inventory confirmation is fresh (`Location.inventoryIsFresh`, 45-day
 *   window decided in spotme-server api/location/searchBoost.ts). Off-platform
 *   closes never touch the count, so an unconfirmed «Última» can be wrong in
 *   BOTH directions — publicidad engañosa either way.
 *
 * The verdict is a server boolean, never a client date comparison: listing
 * and search pages are SSG/ISR, and a `Date.now()` check here would flip
 * across the 45-day boundary between build and hydration (#418). A missing
 * flag reads as NOT fresh — a claim fails closed.
 */
export const isAvailabilityClaimable = (
  config: Pick<IConfiguration, 'dealType' | 'resolvedDealType' | 'price'>,
  inventoryIsFresh: Maybe<boolean> | undefined
): boolean =>
  getEffectiveDealType(config) === DealType.Monthly || inventoryIsFresh === true
